import type { ThemeId } from '../types/theme.types'

const HORIZON_STYLE_BY_THEME = {
  elite: { color: '#65321D', opacity: 0.5 },
  elitePrime: { color: '#DC8090', opacity: 1 }
} as const

const HORIZON_BAND_PATH =
  'M0 7C4.86461 6.5982 9.78931 6.26121 14.711 5.94803C59.184 3.24079 103.725 2.04034 148.273 2C148.277 2 148.281 2 148.285 2C192.309 2.03931 236.351 3.20608 280.284 5.92459C285.217 6.24412 290.13 6.58647 295 7C290.143 6.45307 285.239 5.98369 280.313 5.54382C236.443 1.74813 192.358 0.0392261 148.285 0C148.281 0 148.277 0 148.273 5.96046e-08C103.675 0.0401759 59.0932 1.78397 14.6825 5.57098C9.76818 6.00338 4.85203 6.46615 0 7Z'

const HORIZON_LOWER_EDGE_PATH =
  'M0 7C4.86461 6.5982 9.78931 6.26121 14.711 5.94803C59.184 3.24079 103.725 2.04034 148.273 2C148.277 2 148.281 2 148.285 2C192.309 2.03931 236.351 3.20608 280.284 5.92459C285.217 6.24412 290.13 6.58647 295 7'

/** Theme-tinted horizon curve under the Elite Plans hero. */
export function ElitePlansHeroCurve({ themeId }: { themeId: ThemeId }) {
  const horizon = HORIZON_STYLE_BY_THEME[themeId]

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 295 24'
      preserveAspectRatio='none'
      className='pointer-events-none block w-full select-none'
      aria-hidden='true'
      focusable='false'
    >
      <path d={`${HORIZON_LOWER_EDGE_PATH}L295 24H0Z`} fill='#ffffff' />
      <path d={HORIZON_BAND_PATH} fill={horizon.color} opacity={horizon.opacity} />
    </svg>
  )
}
